import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import './styles/design-system.css';
import './index.css';
import './styles/responsive-overrides.css';
import './styles/presentation-layer.css';
import './styles/rtl-global-fix.css';
import App from './App';

document.documentElement.lang = 'ar';
document.documentElement.dir = 'rtl';
document.body.dir = 'rtl';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
